"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "12", height: "6", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M.6.6L6 5.4 11.4.6", stroke: "#1F1F1F", strokeLinecap: "round", strokeLinejoin: "round" }))); };
exports.default = Component;
//# sourceMappingURL=Arrow.js.map